import { jsx, jsxs } from "react/jsx-runtime";
import { Slider, Stack, Typography } from "@mui/material";
function LineHeightInput(props) {
  const { value, onChange, title } = props;
  return /* @__PURE__ */ jsx(Stack, { flex: "1 1 auto", children: /* @__PURE__ */ jsxs(Stack, { alignItems: "center", direction: "row", gap: 2, children: [
    /* @__PURE__ */ jsxs(
      Typography,
      {
        sx: (theme) => ({
          color: theme.vars.palette.text.secondary,
          flex: "1 1 auto",
          fontSize: 16
        }),
        children: [
          title,
          ": ",
          value
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Slider,
      {
        max: 3,
        min: 0.9,
        onChange: (_, value2) => onChange(value2),
        size: "small",
        step: 0.01,
        value
      }
    )
  ] }) });
}
export {
  LineHeightInput
};
//# sourceMappingURL=LineHeightInput.js.map
